module.exports = "/../../dist/frontend/images/reservation-zoe.webp?bfec2c2d0ecd364559cfe06852b46322";